import React, { useMemo, useContext, useCallback, useEffect, useState, useRef } from "react";
import { Loading } from "@jd/focus-desktop-comps";
import { UAParser } from "ua-parser-js";
import styles from "@/components/styles";
import TabItem from "./TabItem";
import { Button, Dropdown, message } from "antd";
import { PlusOutlined, MinusOutlined, FullscreenOutlined, SearchOutlined } from "@/utils/antdIcon";
import WinToolbar from "@/layout/WinToolbar";
import { BrowserViewContext, BrowserViewItem } from "./utils";
// import logo from '@/components/icon/logo16x16.png';
import { useTranslation } from "react-i18next";
import { getDefaultPageFavicon } from "@/utils/oss";
import thirdAppAnalyticsMap from "@/utils/thirdAppAnalyticsMap";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { changeEgovUrl } from "@/utils/tools";
import { FocusSDK, isFocusEnv } from "@/utils";
import Bus from "@/utils/bus";
import IconFont, {
  IconArrowLeft,
  IconArrowRight,
  IconScale,
  IconClearcCache
} from "@/components/icon";
import ImService from "@/server/ImService";
import CopyClipboard from "copy-to-clipboard";
import { checkJoyspaceUrlAll } from "@/components/Joyspace/util";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { logoIcon } from "@/utils/imges";

// import 'antd/dist/antd.css';
import "./Tabs.less";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import { ContactShowType } from "@jd/focus-desktop-comps/lib/es/UserSelection/types";

import favIco from "../../assets/templateImgs/logo.png";
import { generateMessageId } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import { SelectorMode, UserSelTab } from "@jd/focus-desktop-comps/lib/es/UserSelection";
import { connect } from "dva";
import { ChatMessageType } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";

// const logoIcon = process.env.REACT_APP_OSS_BASE_URL
//   ? `${process.env.REACT_APP_OSS_BASE_URL}/statics/images/icon.png`
//   : favIco;

function TabIcon({ src }: { src: string }) {
  const [loaded, setLoaded] = useState(false);
  React.useEffect(() => {
    if (loaded) {
      return;
    }
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setLoaded(true);
    };
  }, [src, loaded]);

  if (!loaded) {
    return <img width={16} height={16} src={logoIcon} alt="" style={{ borderRadius: 5 }} />;
  }

  return <img width={16} height={16} src={changeEgovUrl(src)} alt="" style={{ borderRadius: 2 }} />;
}

// eslint-disable-next-line complexity
function Tabs(props: { onTabChange: (id: string) => void; shareContentMap: any }) {
  const {
    onWindowClose,
    items,
    selectedId,
    toolMenuVisible,
    setToolMenuVisible,
    shareableObj,
    defaultPage,
    configData = { allowedHosts: [], partition: "builtin-third-apps" }
  } = React.useContext(BrowserViewContext);
  const [doubleClickTrigger, setDoubleClickTrigger] = useState(1);
  const { focusSDK, authInfo, imService } = useContext<GlobalContextConfig>(GlobalContext);
  const { onTabChange, shareContentMap } = props;
  const [open, setOpen] = useState(false);
  const [tabItems, setTabItems] = useState<BrowserViewItem[]>([]); // 标签数据
  const [routerCanGoBack, setRouterCanGoBack] = useState(false);
  const [routerCanGoForward, setRouterCanGoForward] = useState(false);
  const [scalePercent, setScalePercent] = useState(100);
  const elementRef = useRef(null);
  const [itemWidth, setItemWidth] = useState(180); // 标签宽度
  const isDraggingRef = useRef(false);
  const droppableRef = useRef<any>(null);
  const dragDropContextRef = useRef<any>(null);

  const appInfo = items.filter((item: any) => {
    return item.id === selectedId;
  })[0];
  const { t } = useTranslation("common");
  const isMac = useMemo(() => {
    let platform = focusSDK.getDeviceInfo().platform;
    if (platform === "web") {
      let uaParser = new UAParser();
      let os = uaParser.getOS();
      return (os?.name as string).indexOf("Mac") > -1 || (os?.name as string).indexOf("iOS") > -1;
    }
    return platform === "darwin";
  }, [focusSDK]);

  // 根据id获取对应索引
  const findIndex = (item: BrowserViewItem, list: BrowserViewItem[]) => {
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === item.id) {
        return i;
      }
    }
    return -1;
  };
  // 打开页签数据变化后重新设置标签数据
  useEffect(() => {
    const list = tabItems;
    items.forEach((item: any) => {
      const index = findIndex(item, tabItems);
      if (index === -1) {
        list.push(item);
      } else {
        list[index] = item;
      }
    });
    list.forEach((item, idx) => {
      if (findIndex(item, items) === -1) {
        list.splice(idx, 1);
      }
    });
    setTabItems(JSON.parse(JSON.stringify(list)));
  }, [items]);

  // 计算每个页签的宽度
  const doSetItemWidth = useCallback(() => {
    if (elementRef) {
      // @ts-ignore
      const clientWidth = elementRef?.current?.clientWidth || 0;
      const itemWidth = clientWidth / (tabItems.length || 1);
      if (clientWidth) {
        setItemWidth(itemWidth > 180 ? 180 : itemWidth);
      }
    }
  }, [elementRef, tabItems]);
  // 计算每个页签的宽度
  useEffect(() => {
    if (elementRef) {
      // @ts-ignore
      const clientWidth = elementRef?.current?.clientWidth || 0;
      const itemWidth = clientWidth / (items.length || 1);
      if (clientWidth) {
        setItemWidth(itemWidth > 180 ? 180 : itemWidth);
      }
    }
  }, [elementRef, items]);

  const handleResize = () => {
    doSetItemWidth();
  };

  // 通过触发鼠标事件强制拖动结束
  const forceDragEnd = () => {
    if (isDraggingRef.current) {
      const event = new CustomEvent("mouseup");
      window.dispatchEvent(event);
    }
  };

  // 检查鼠标是否在拖拽区域内
  const isMouseInDroppableArea = (e: any) => {
    if (!droppableRef.current) return false;
    const rect = droppableRef.current.getBoundingClientRect();
    return (
      e.clientX >= rect.left &&
      e.clientX <= rect.right &&
      e.clientY >= rect.top &&
      e.clientY <= rect.bottom
    );
  };

  useEffect(() => {
    let lastMousePosition = { x: 0, y: 0 };
    let isOutsideTimeout: any = null;

    const handleMouseMove = (e: any) => {
      if (!isDraggingRef.current) return;
      lastMousePosition = { x: e.clientX, y: e.clientY };
      // 清除之前的超时
      if (isOutsideTimeout) {
        clearTimeout(isOutsideTimeout);
      }
      // 检查是否在拖拽区域内
      const isInside = isMouseInDroppableArea(e);
      console.log("isInside", isInside);
      // 如果不在区域内，设置一个短暂的延迟后触发结束
      if (!isInside) {
        isOutsideTimeout = setTimeout(() => {
          if (
            !isMouseInDroppableArea({ clientX: lastMousePosition.x, clientY: lastMousePosition.y })
          ) {
            console.log(12312);
            forceDragEnd();
          }
        }, 100); // 100ms 的延迟
      }
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      if (isOutsideTimeout) {
        clearTimeout(isOutsideTimeout);
      }
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [tabItems]);

  const handleItemClose = useCallback(
    (item: any) => {
      if (onWindowClose) {
        onWindowClose(item.id);
      }
      if (isFocusEnv() && item.name === "智能会议") {
        FocusSDK.sendMainMessage("jdmeet.chatEvent", {
          type: "close-live-chat"
        });
      }
    },
    [onWindowClose]
  );

  const handleCtrlW = useCallback(() => {
    console.log("hahahahahactrlWWWcall", selectedId);
    if (selectedId === "startup-page") {
      FocusSDK.closeWindow();
    } else {
      onWindowClose?.(selectedId || "");
    }
  }, [onWindowClose, selectedId]);
  const handleCtrl0 = useCallback(() => {
    console.log("presss-ctrl+0");
    Bus.emit(`${selectedId}handleZoomReset`);
  }, [selectedId]);
  const handleCtrlPlus = useCallback(() => {
    console.log("press-ctrl+plus");
    Bus.emit(`${selectedId}handleZoomIn`);
  }, [selectedId]);
  const handleCtrlMinus = useCallback(() => {
    console.log("press-ctrl+minus");
    Bus.emit(`${selectedId}handleZoomOut`);
  }, [selectedId]);
  const handleF5 = useCallback(() => {
    console.log("press-f5");
    Bus.emit(`${selectedId}refreshCb`);
  }, [selectedId]);
  const handleSearch = useCallback(() => {
    console.log("search");
    handleOpenChange(false);
    Bus.emit(`${selectedId}searchCb`);
  }, [selectedId]);
  const handleCancelSearch = useCallback(() => {
    console.log("cancel search");
    Bus.emit(`${selectedId}cancelSearchCb`);
  }, [selectedId]);
  useEffect(() => {
    focusSDK.on("press-ctrl+w", handleCtrlW);
    focusSDK.on("press-ctrl+0", handleCtrl0);
    focusSDK.on("press-ctrl+plus", handleCtrlPlus);
    focusSDK.on("press-ctrl+minus", handleCtrlMinus);
    focusSDK.on("press-f5", handleF5);
    focusSDK.on("clear-cache-CallBack", clearCacheCallBack);
    focusSDK.on("press-esc", handleCancelSearch);
    isFocusEnv() &&
      FocusSDK?.windowInfo?.windowId !== 1 &&
      focusSDK.on("press-ctrl+f", handleSearch);

    return () => {
      focusSDK.off("press-ctrl+w", handleCtrlW);
      focusSDK.off("press-ctrl+0", handleCtrl0);
      focusSDK.off("press-ctrl+plus", handleCtrlPlus);
      focusSDK.off("press-ctrl+minus", handleCtrlMinus);
      focusSDK.off("press-f5", handleF5);
      focusSDK.off("clear-cache-CallBack", clearCacheCallBack);
      focusSDK.off("press-esc", handleCancelSearch);
      isFocusEnv() &&
        FocusSDK?.windowInfo?.windowId !== 1 &&
        focusSDK.off("press-ctrl+f", handleSearch);
    };
  }, [
    focusSDK,
    handleCtrl0,
    handleCtrlMinus,
    handleCtrlPlus,
    handleCtrlW,
    handleF5,
    handleSearch,
    handleCancelSearch
  ]);
  const handleGobackBtnChange = (value: any) => {
    setRouterCanGoBack(value);
  };
  const handleGoforwardBtnChange = (value: any) => {
    setRouterCanGoForward(value);
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleWvScaleChange = (value: any) => {
    setScalePercent(value);
  };
  const handleWvSearch = () => {
    console.log("handleWvSearch", selectedId);
    if (selectedId !== "startup-page") {
      handleSearch();
    } else {
      focusSDK.emit("openGlobalSearch");
    }
  };
  useEffect(() => {
    Bus.on("goback-btn-change", handleGobackBtnChange);
    Bus.on("goforward-btn-change", handleGoforwardBtnChange);
    Bus.on("wv-scale-change", handleWvScaleChange);
    Bus.on("handleWvSearch", handleWvSearch);
    return () => {
      Bus.off("goback-btn-change", handleGobackBtnChange);
      Bus.off("goforward-btn-change", handleGoforwardBtnChange);
      Bus.off("wv-scale-change", handleWvScaleChange);
      Bus.off("handleWvSearch", handleWvSearch);
    };
  }, [selectedId]);

  let startupPage = null;
  if (defaultPage) {
    const { title, icon, id } = defaultPage;
    startupPage = (
      <TabItem
        icon={icon}
        name={title}
        minWidth={150}
        active={selectedId === defaultPage.id}
        withoutClose
        onClick={() => {
          onTabChange(id);
        }}
      />
    );
  }

  const goBackCb = () => {
    Bus.emit(`${selectedId}goBackCb`);
  };
  const goForwardCb = () => {
    Bus.emit(`${selectedId}goForwardCb`);
  };
  const refreshCb = () => {
    console.log(`${selectedId}refreshCb`, "refreshCb");
    Bus.emit(`${selectedId}refreshCb`);
  };
  const handleZoomOut = () => {
    Bus.emit(`${selectedId}handleZoomOut`);
  };
  const handleZoomIn = () => {
    Bus.emit(`${selectedId}handleZoomIn`);
  };
  const openThirdappNewWindow = (item: any) => {
    Bus.emit(`${selectedId}openThirdappNewWindow`);
    handleItemClose(item);
  };
  const handleFullScreen = () => {
    Bus.emit(`${selectedId}fullScreen`);
  };

  const reloadIgnoringCache = () => {};
  const routerRefreshToolBar = (
    <div className="router-refresh-tool-bar" onDoubleClick={(e) => e.stopPropagation()}>
      <Button
        className="no-draggable"
        type="text"
        size="small"
        disabled={!routerCanGoBack}
        onClick={goBackCb}
      >
        {IconArrowLeft}
      </Button>
      <Button
        className="no-draggable"
        type="text"
        size="small"
        disabled={!routerCanGoForward}
        onClick={goForwardCb}
      >
        {IconArrowRight}
      </Button>
      <Button
        className="no-draggable"
        type="text"
        size="small"
        onClick={refreshCb}
        onDoubleClick={reloadIgnoringCache}
      >
        <IconFont type="iconic_pc_refresh11" style={{ fontSize: "16px" }} />
      </Button>
      {/* <Button className="no-draggable" type="text" size="small" onClick={handleFullScreen}>
        <FullscreenOutlined />
      </Button> */}
    </div>
  );
  const handleWorkbenchRefresh = () => {
    Bus.emit("workbenchRefreshCb", { partition: configData.partition });
    console.log("handleWorkbenchRefresh");
  };
  const workbenchRefreshToolBar = (
    <div className="router-refresh-tool-bar" onDoubleClick={(e) => e.stopPropagation()}>
      <Button className="no-draggable" type="text" size="small" disabled>
        {IconArrowLeft}
      </Button>
      <Button className="no-draggable" type="text" size="small" disabled>
        {IconArrowRight}
      </Button>
      <Button className="no-draggable" type="text" size="small" onClick={handleWorkbenchRefresh}>
        <IconFont type="iconic_pc_refresh11" style={{ fontSize: "16px" }} />
      </Button>
    </div>
  );
  const item = items.find((item: BrowserViewItem) => {
    return item.id === selectedId;
  });

  const handleOpenChange = (flag: boolean) => {
    setOpen(flag);
    setToolMenuVisible?.(flag);
  };

  const clearCacheCallBack = (data: any) => {
    if (data.selectedId !== selectedId) return;
    if (data.status === "success") {
      message.success("应用的缓存清除成功");
    } else {
      message.error("请稍候再试");
    }
  };

  const clearCacheCb = () => {
    Bus.emit(`${selectedId}ClearCache`);
  };

  const onDragStart = () => {
    isDraggingRef.current = true;
  };

  // 当页签拖拽结束时重新设置页签数据
  const onDragEnd = (result: any) => {
    isDraggingRef.current = false;
    if (!result.destination) {
      return;
    }
    if (!result || !result.destination || !result.destination) {
      return;
    }
    const fromIndex = result.source.index;
    const toIndex = result.destination.index;
    const id = tabItems[fromIndex].id;
    if (fromIndex === undefined || id === undefined || toIndex === undefined) {
      return;
    }
    const [reorderedItem] = tabItems.splice(fromIndex, 1);
    tabItems.splice(toIndex, 0, reorderedItem);
    setTabItems(tabItems);
    onTabChange(id);
  };

  const getItemStyle = (isDragging: boolean, draggableStyle: any) => {
    const transform = draggableStyle?.transform;
    const transformMatch = transform?.match(/translate\(([-\d.]+)px/);
    let horizontalTransform = transform;
    if (transformMatch) {
      horizontalTransform = `translate(${transformMatch[1]}px, 0px)`;
    }
    return {
      ...draggableStyle,
      transform: horizontalTransform
    };
  };

  const sendMessage = async (sessionId: string, mId: string) => {
    const wv: any = document.getElementById(`thridapp-${selectedId}`);
    const link = wv?.src;
    const shareStr = selectedId ? shareContentMap[selectedId] : {};
    const shareObj = shareStr ? JSON.parse(shareStr) : {};
    const url = shareObj?.linkUrl || shareObj?.url || link;
    const title = shareObj?.title || item?.name || "内容分享";
    const content =
      shareObj?.content || shareObj?.subTitle || item?.description || "请点击卡片，查看内容详情";
    const icon = shareObj?.icon || shareObj?.iconUrl || item?.originIcon || null;

    await imService.sendChatMessage(sessionId, mId, {
      type: "text",
      content: url,
      nativeId: "share_link",
      displayContent: [
        {
          content: title,
          url,
          egovWebUrl: shareObj?.egovLinkUrl,
          type: "HttpTopic",
          startIndex: 0
        }
      ],
      data: {
        fileName: title,
        fileContent: content,
        iconUrl: icon,
        source: 1,
        webUrl: url,
        egovWebUrl: shareObj?.egovLinkUrl,
        egovIconUrl: shareObj?.egovIconUrl
      }
    } as any);
  };

  return (
    <div
      className={`me-thirdapp-tabs-header ${
        isFocusEnv() && FocusSDK?.windowInfo?.windowId !== 1 ? "draggable" : ""
      }`}
      style={{
        height: 48,
        backgroundColor: "#F5F6F8",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-end",
        paddingLeft: isFocusEnv() && isMac && FocusSDK?.windowInfo?.windowId !== 1 ? 65 : 0,
        paddingRight:
          selectedId !== "startup-page"
            ? isMac
              ? 60
              : isFocusEnv() && FocusSDK?.windowInfo?.windowId !== 1
              ? 167
              : 60
            : 0
      }}
    >
      {selectedId !== "startup-page" && routerRefreshToolBar}
      {selectedId === "startup-page" && workbenchRefreshToolBar}
      {startupPage}
      {/* <TabItem
        icon={IconFont('iconapp_tabbar_application')}
        name="应用中心"
        active={!activeId}
        withoutClose
        onClick={() => {
          onTabChange('');
        }}
      /> */}
      <div
        ref={elementRef}
        style={{
          display: "flex",
          flexGrow: 1,
          overflow: "hidden",
          paddingBottom: "1px",
          // @ts-ignore
          "-webkit-app-region": "no-drag"
        }}
      >
        <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart} ref={dragDropContextRef}>
          <Droppable
            droppableId="droppable"
            ignoreContainerClipping
            direction="horizontal"
            // @ts-ignore
            style={{}}
          >
            {(provided) => (
              <>
                <div
                  {...provided.droppableProps}
                  ref={(el) => {
                    provided.innerRef(el);
                    droppableRef.current = el;
                  }}
                  className="draggable-item-content"
                  style={{}}
                >
                  {tabItems.map((item, index) => (
                    <Draggable key={item.id} draggableId={item.id} index={index}>
                      {(provided, snapshot) => (
                        <span
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                        >
                          <TabItem
                            icon={
                              item.isApplications || item.isNewThirdappAnalysis ? (
                                item.icon && item.icon?.props?.type ? (
                                  <IconFont type={item.icon?.props?.type} />
                                ) : (
                                  <IconFont type="iconic_pc_statistics" />
                                )
                              ) : item.icon ? (
                                <TabIcon src={changeEgovUrl(item.icon)} />
                              ) : (
                                <Loading size={16} />
                              )
                            }
                            key={item.id}
                            minWidth={itemWidth}
                            maxWidth={itemWidth}
                            name={item.name || t("browserView.defaultTabTitle")}
                            active={item.id === selectedId}
                            clstag={thirdAppAnalyticsMap[item.appKey || ""]?.close}
                            onItemClose={() => {
                              if (onWindowClose) {
                                console.log("selectedId", selectedId);
                                onWindowClose(item.id);
                              }
                              if (isFocusEnv() && item.name === "智能会议") {
                                ImService.getInstance().closeLive();
                              }
                              handleItemClose(item);
                            }}
                            onContextMenu={() => {
                              if (focusSDK.isBeta()) {
                                Bus.emit(`${selectedId}openDevtools`);
                              }
                            }}
                            onClick={() => {
                              onTabChange(item.id);
                            }}
                            itemsLength={tabItems.length}
                          />
                        </span>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
                <div
                  style={{
                    // @ts-ignore
                    "-webkit-app-region": "drag",
                    width: "100%"
                  }}
                />
              </>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      {selectedId !== "startup-page" && appInfo?.appKey !== "all-thirapp" && (
        <div className="tool-bar-more no-draggable">
          {(
            shareableObj[item?.id || ""] !== undefined
              ? shareableObj[item?.id || ""]
              : item?.shareStatus
          ) ? (
            <Button
              className="btn"
              type="text"
              size="small"
              onClick={() => {
                openUserSelectionDefaultModal(
                  {
                    title: "分享",
                    tabs: [
                      "recentIncludeGroup",
                      "org",
                      "workLine",
                      "externalContacts",
                      "groupCanBeSel"
                    ],
                    recommendParam: {
                      keyWords: "",
                      aiType: ["empl"]
                    },
                    currentUser: {
                      pin: authInfo?.userId || "",
                      app: authInfo?.ddAppId || "",
                      teamId: authInfo?.teamUserInfo?.teamId || ""
                    },
                    tabSort: [{ tab: UserSelTab.recentIncludeGroup, sort: 1 }]
                  },
                  async (data: any, close: any) => {
                    const { result } = data.data;
                    if (!result.length) {
                      return close();
                    }
                    result.forEach(async (item: any) => {
                      if (item.isGroup) {
                        const mId = generateMessageId();
                        sendMessage(item.id, mId);
                        return;
                      } else {
                        const session = await imService.createSingleSession({
                          app: item.app,
                          pin: item.pin,
                          teamId: item.teamId
                        });
                        if (session) {
                          const mId = generateMessageId();
                          sendMessage(session.sessionId, mId);
                        }
                      }
                    });
                    close();
                  },
                  authInfo
                );
              }}
            >
              <IconFont type="iconic_pc_taskshare" style={{ fontSize: "16px" }} />
            </Button>
          ) : (
            ""
          )}
          <Dropdown
            trigger={["click"]}
            overlay={
              <div className="drop-down-box" onDoubleClick={(e) => e.stopPropagation()}>
                <div className="drop-down-item">
                  <Button className="icon" type="text" size="small">
                    {IconScale}
                  </Button>
                  <Button className="btn" type="text" size="small" onClick={handleZoomOut}>
                    <MinusOutlined />
                  </Button>
                  <span style={{ margin: "0 18px" }}>{scalePercent.toFixed(0)}%</span>
                  <Button className="btn" type="text" size="small" onClick={handleZoomIn}>
                    <PlusOutlined />
                  </Button>
                  {/* <span style={{ margin: "0 10px", verticalAlign: "top" }} />
                  <Button className="btn" type="text" size="small" onClick={handleFullScreen}>
                    <FullscreenOutlined />
                  </Button> */}
                  {((!item?.isNewWin &&
                    item?.isThirdApp &&
                    configData.partition === "builtin-third-apps") ||
                    configData.partition === "builtin-home-apps") && authInfo && (
                    <>
                      <span style={{ margin: "0 20px", verticalAlign: "top" }}> | </span>
                      <Button
                        className="btn"
                        type="text"
                        size="small"
                        onClick={() => {
                          openThirdappNewWindow(item);
                          handleOpenChange(false);
                        }}
                      >
                        <IconFont type="iconic_pc_alone" style={{ fontSize: "16px" }} />
                      </Button>
                    </>
                  )}
                </div>
                <div className="drop-down-item">
                  <Button className="icon" type="text" size="small">
                    {IconClearcCache}
                  </Button>
                  <span onClick={clearCacheCb}>
                    <span className="operation-text">清除缓存</span>
                    <span className="operation-text-remark">（cookie+缓存）</span>
                  </span>
                </div>
                <div className="drop-down-item">
                  <Button className="icon" type="text" size="small">
                    {IconClearcCache}
                  </Button>
                  <span onClick={handleSearch}>
                    <SearchOutlined />
                    <span className="operation-text">搜索</span>
                    {/* <span className="operation-text-remark">（Ctrl+F）</span> */}
                  </span>
                </div>
                {(
                  shareableObj[item?.id || ""] !== undefined
                    ? shareableObj[item?.id || ""]
                    : item?.shareStatus
                ) ? (
                  <div className="drop-down-item">
                    <Button className="icon" type="text" size="small">
                      {IconClearcCache}
                    </Button>
                    <span
                      onClick={() => {
                        const wv: any = document.getElementById(`thridapp-${selectedId}`);
                        const link = wv?.src;
                        if (link && CopyClipboard(link || "")) {
                          message.success("复制链接成功");
                        } else {
                          message.error("复制链接失败");
                        }
                      }}
                    >
                      <IconFont type="iconwin_link" style={{ fontSize: "16px" }} />
                      <span className="operation-text">复制链接</span>
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            }
            placement="bottomRight"
            visible={toolMenuVisible}
            onVisibleChange={handleOpenChange}
          >
            <div className="icon-wrap">
              <IconFont type="iconlog_more" className="icon" />
            </div>
          </Dropdown>
          {isFocusEnv() && FocusSDK?.windowInfo?.windowId !== 1 && (
            <div className="win-tool-bar-wrap" style={!isMac ? {} : { display: "none" }}>
              <WinToolbar isclosewin={true} wrapperDoubleClickTrigger={doubleClickTrigger} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function mapStateToProps(props: { thirdapp: any }) {
  const { thirdapp } = props;
  return {
    shareContentMap: thirdapp.shareContentMap
  };
}

export default connect(mapStateToProps)(Tabs);
